import { ReactNode } from "react";
import { flex } from "../../styled-system/patterns";

interface PageTitleProps {
  children: ReactNode;
}

export function PageTitle({ children }: PageTitleProps) {
  return (
    <h1
      className={flex({
        textStyle: "heading.m",
        height: "48px",
        justify: "center",
        alignItems: "center",
        bgColor: "black.100",
      })}
    >
      {children}
    </h1>
  );
}
